export default __webpack_public_path__ + "static/media/feature-handshake.d499a22f.png";